export const environment = {
    production: true,
      //apiUrl: "http://api.sharedsystem.com" 
   apiUrl: "https://assurance-etudiant.prevas.ma/api"

};
